/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronsUpLeft = createReactComponent("chevrons-up-left", "IconChevronsUpLeft", [
  ["path", { d: "M7 15v-8h8", key: "svg-0" }],
  ["path", { d: "M11 19v-8h8", key: "svg-1" }]
]);

export { IconChevronsUpLeft as default };
//# sourceMappingURL=IconChevronsUpLeft.js.map
